// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';

import * as selectors from '../../reducers';
import PopupContainer from '../PopupContainer';
import NotificationsListPopover from '../NotificationsListPopover';
import NotificationPopoverContent from '../NotificationPopoverContent';
// import styles from './notificationPopover.css';


type NotificationPopoverPropTypes = {
  screen: number
};

const NotificationPopoverDummy = ({
  screen = 1,
  ...props
}: NotificationPopoverPropTypes) => {
  let PopupContent = NotificationsListPopover;
  switch (screen) {
    case 2: {
      PopupContent = NotificationPopoverContent;
      break;
    }
    default: {
      PopupContent = NotificationsListPopover;
      break;
    }
  }

  return (
    <Fragment>
      <PopupContainer isRound {...props}>
        <PopupContent {...props} />
      </PopupContainer>
    </Fragment>
  );
};

const NotificationPopover = connect(
  state => ({
    screen: selectors.getCurrentScreen(state),
  }),
  null,
)(NotificationPopoverDummy);

export default NotificationPopover;



// WEBPACK FOOTER //
// ./src/scripts/components/NotificationPopover/index.jsx